import * as API from '@/services/API';

export default {
  getSuburbsByNameOrPostCode(name) {
    return API.apiClient.get(`/suburbs/?title=${name}`);
  }
};
